<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Detalles del Contenedor</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button type="button" @click="enviar" class="btn-success btn--text">
            <i class="fa fa-share"></i><span>Enviar</span>
          </button>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <table>
        <thead>
          <tr>
            <th>Localización</th>
            <th>TPI</th>
            <th>Alto</th>
            <th>Ancho</th>
            <th>Cantidad</th>
            <th>Componente</th>
            <th>Método de reparación</th>
            <th>Descripción</th>
            <th>Tipo de material</th>
            <th>Lb. Rate</th>
            <th>Handling total</th>
            <th>Total Tax</th>
            <th>Horas hombre</th>
            <th>Precio</th>
            <th>Damage</th>
            <th>Tipo unidad</th>
            <th>Enviar en EDI</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-show="form.detalles.length === 0">
            <td colspan="13">
              <strong>No se ha agregado detalles.</strong>
            </td>
          </tr>
          <tr v-if="form.detalles.length !== 0">
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>
              <label for="enviar_edi_todos">
                <input v-model="form.enviar_todos" id="enviar_edi_todos" type="checkbox" @change="changeTodos"/>
                <span></span>
              </label>
            </td>
            <td></td>
          </tr>
          <tr v-for="(detalle, index) in form.detalles" :key="detalle.id">
            <td>
              {{ detalle.localizacion_id_edi }}
            </td>
            <td>
              {{ detalle.tpi_edi }}
            </td>
            <td>
              {{ detalle.dimension_edi }}
            </td>
            <td>
              {{ detalle.dimension2_edi }}
            </td>
            <td>
              {{ parseFloat(detalle.pieza_edi) }}
            </td>
            <td>
              {{ detalle.codigo_rep_edi }}
            </td>
            <td>
              {{ detalle.repair_method_edi }}
            </td>
            <td>
              {{ detalle.descripcion_edi }}
            </td>
            <td>
              {{ detalle.tipo_material_edi }}
            </td>
            <td>
              {{ detalle.labour_rate_edi }}
            </td>
            <td>
              {{ detalle.handling_total_edi }}
            </td>
            <td>
              {{ detalle.tax_total_edi }}
            </td>
            <td>
              {{ detalle.horas_hombre_edi }}
            </td>
            <td>
              {{ detalle.precio_edi }}
            </td>
            <td>
              {{ detalle.damage_code }}
            </td>
            <td>
              {{ detalle.tipo_unidad }}
            </td>
            <td>
              <label :for="'enviar_edi' + detalle.id">
                <input
                  v-model="detalle.bool_enviar_edi"
                  type="checkbox"
                  @change="changeIndividual"
                  :id="'enviar_edi' + detalle.id"
                /><span></span>
              </label>
            </td>
            <td>
              <button
                type="button"
                @click="editar(index)"
                class="btn--text btn-info"
              >
                <i class="fa fa-edit"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-show="form.detalles.length !== 0" class="col-md-12 form-inline">
        <div>
          <p>Horas hombre: {{ horas_hombre }}</p>
        </div>
        <div>
          <p>Costo material: {{ precio }}</p>
        </div>
        <div>
          <p>Total labor: {{ total_labor }}</p>
        </div>
        <div>
          <p>Total caja: {{ form.propiedades.amount_b }}</p>
        </div>
        <div>
          <p>Total máquina: {{ form.propiedades.amount_m }}</p>
        </div>
      </div>
    </div>
    <div class="modal-buttons">
      <button @click="guardar" class="btn-success">
        <i class="fa fa-save"></i><span>Guardar</span>
      </button>
      <button @click="$emit('cerrar')" class="btn-danger btn--text">
        <i class="fa fa-times"></i><span>Cerrar</span>
      </button>
    </div>
    <modal
      :clickToClose="false"
      name="detalle"
      height="auto"
      width="80%"
      adaptive
      resizable
      reset
      scrollable
    >
      <detalle
        v-model="selectedDetalle"
        @input="inputDetalle"
        @cerrar="$modal.hide('detalle')"
      ></detalle>
    </modal>
  </div>
</template>

<script>
import Detalle from "./Detalle.vue";
export default {
  components: {
    Detalle,
  },
  props: {
    number: {
      type: String,
      required: false,
      default: "",
    },
    secuencia: {
      required: false,
    },
  },
  methods: {
    enviar: function () {
      swal({
        title: `¿Deseas enviar el EDI de estimado?`,
        text: "Se enviará el EDI de estimado",
        type: "question",
        showCancelButton: true,
        confirmButtonText: `Enviar`,
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          axios
            .post(url + "/propiedades/" + this.number + "/estimado")
            .then(({ data }) => {
              if (data.edi)
                swal(
                  "El proceso de envío de EDI fue correcto.",
                  "Realizado",
                  "success"
                );
              else
                swal("Hubo un problema al enviar el EDI.", "Aviso", "warning");
            })
            .catch(() => {
              swal("Hubo un error, intente nuevamente.", "Error", "error");
            });
        }
      });
    },
    editar: function (index) {
      this.currentIndex = index;
      this.selectedDetalle = this.form.detalles[index];
      this.$modal.show("detalle");
    },
    cargarDetalles: function () {
      axios
        .get(
          url +
            "/propiedades/" +
            this.number +
            "/detalles" +
            (this.secuencia != null && this.secuencia != ""
              ? "/" + this.secuencia
              : "")
        )
        .then(({ data }) => {
          this.form.detalles = data.detalles;
          this.form.propiedades = {
            'amount_b': round(data.propiedades.amount_b, precision), 
            'amount_m': round(data.propiedades.amount_m, precision)
          };
        })
        .catch(() => {
          swal(
            "Hubo un error al momento de cargar los detalles.",
            "Error",
            "error"
          );
        });
    },
    guardar: function () {
      axios
        .post(url + "/propiedades/" + this.number + "/detalles", this.form)
        .then(() => {
          swal(
            "Los detalles fueron actualizados exitósamente.",
            "Realizado",
            "success"
          );
        })
        .catch(() => {
          swal("Hubo un error, intente nuevamente.", "Error", "error");
        });
    },
    inputDetalle: function (detalle) {
      this.form.detalles.splice(this.currentIndex, 1, detalle);
      this.$modal.hide("detalle");
    },
    changeTodos: function () {
      if (this.form.enviar_todos) {
        this.form.detalles.forEach( detalle => {
          detalle.bool_enviar_edi = true;
        });
      }
      else {
        this.form.detalles.forEach( detalle => {
          detalle.bool_enviar_edi = false;
        });
      }
    },
    changeIndividual: function () {
      this.form.enviar_todos = false;
    }
  },
  computed: {
    horas_hombre: function () {
      let horas_hombre_edi = 0;
      this.form.detalles.map( detalle => horas_hombre_edi += +detalle.horas_hombre_edi );
      return round(horas_hombre_edi, precision);
    },
    precio: function () {
      let precio_edi = 0;
      this.form.detalles.map( detalle => precio_edi += +detalle.precio_edi );
      return round(precio_edi, precision);
    },
    total_labor: function () {
      let total_labor = 0;
      this.form.detalles.map( detalle => total_labor += ( (detalle.horas_hombre_edi * detalle.labour_rate_edi) + (+detalle.pieza_edi * detalle.precio_edi) ));
      return round(total_labor, precision);
    }
  },
  mounted: function () {
    this.cargarDetalles();
  },
  data: function () {
    return {
      form: {
        detalles: [],
        propiedades: {},
        enviar_todos: false
      },
      selectedDetalle: null,
      currentIndex: -1,
    };
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/sistema/EditarDetalles.vue